<template>
  <section class="forgetPassword">
    <header>
      <div class="logoBox"></div>忘记密码
    </header>
    <div class="content">
		<el-steps :active="activeStep" :finish-status="activeStep === 1 ? 'success' : ''" simple style="margin-top: 20px" >
			<el-step title="身份验证"></el-step>
			<el-step title="修改密码"></el-step>
			<el-step title="完成"></el-step>
		</el-steps>
		<div class="formContent">
			<forget-password-step1 v-if="activeStep != 2" @update="activeStepChange" :activeStep='activeStep'></forget-password-step1>
			<!-- <forget-password-step2 v-if="activeStep === 1" @update="activeStepChange"></forget-password-step2> -->
			<div class="form1" v-if="activeStep === 2">
				<div class="successIcon"></div>
				<label class="tip">修改成功</label>
				<el-button @click="backLogin">返回登入</el-button>
			</div>
		</div>
	</div>
  </section>
</template>

<script>
import { LoginService } from "../../service/login.service";
import forgetPasswordStep1 from './forgetPasswordStep1'
// import forgetPasswordStep2 from './forgetPasswordStep2'
import Axios from "axios";
import { Message } from "element-ui";
export default {
	name: "forgetPassword",
	components: {forgetPasswordStep1  },
	data() {
		return {
		form: {
			phone: "",
			select: "phone"
		},
		type: "手机号",
		activeStep: 0,
		selectData: [
			{ label: "手机号", value: "phone" },
			{ label: "邮箱", value: "email" }
		],
		form1Success: false,
		numAImg_src: "",
		graphCode: ""
		};
	},
	created() {
		this.reflashNumA();
	},
	methods: {
		success1() {
			this.form1Success = true;
		},
		activeStepChange(val){
			this.activeStep = val
		},
		// 发送验证码
		async sendCode() {
			if (this.form.select === "phone") {
				await LoginService.smsCodeSend(
				this.$refs.form1.formValue.account,
				"userResetPwd",
				this.graphCode
				);
			} else if (this.form.select === "email") {
				await LoginService.sendEmailCode(
				this.$refs.form1.formValue.account,
				"userResetPwd",
				this.graphCode
				);
			}
			this.success1();
			Message.success("发送成功");
		},
		// 获取验证码图片
		reflashNumA() {
		var url ="https://api.goodyiyao.cn/web/other/digitalVerificationCode?model=userResetPwd";
			Axios.get(url, {
				responseType: "arraybuffer",
				withCredentials: true
			}).then(res => {
				let codeImg ="data:image/png;base64," +btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte),""));
				this.numAImg_src = codeImg;
			});
		},
		checkPhone(){
			this.activeStep = 1
		},
		backLogin() {
			this.$router.replace("/login");
		}
	}
};
</script>

<style lang="scss" scoped>
	.forgetPassword {
		height: 100%;
		header {
			width: 100%;
			height: 100px;
			margin-bottom: 80px;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			padding-left: 150px;
			background: rgb(46, 152, 213);
			font-size: 18px;
			color: #fff;
			.logoBox {
			height: 50px;
			margin-right: 20px;
			width: 170px;
			text-align: left;
			color: #727272;
			background: url("../../assets/images/views/logo.png");
			background-size: 100% 100%;
			}
		}

		.content {
			width: 100%;
			min-width: 800px;
			padding: 0 200px;
			box-sizing: border-box;
			.btn {
			margin-left: 10px;
			margin-bottom: 10px;
			}
		}
		.verify {
			margin-bottom: 10px;
		}
		.formContent {
			display: flex;
			justify-content: center;
		}
		.form1 {
			display: flex;
			width: 100%;
			align-items: center;
			flex-direction: column;
			margin-top: 20px;
		}
	}
	.graphCode {
		display: flex;
		align-items: flex-end;
		flex-direction: column;
		img {
			height: 60px;
			width: 180px;
			margin: 10px 0;
		}
	}
	.sendbtn {
		position: absolute;
		margin: 3px 10px;
	}
	.successIcon {
		border-radius: 50%;
		height: 100px;
		width: 100px;
		background: rgb(53, 187, 0);
		position: relative;
		margin-bottom: 20px;
		&::before {
			content: " ";
			height: 50px;
			width: 30px;
			position: absolute;
			left: 50%;
			top: 50%;
			margin-top: -36px;
			margin-left: -15px;
			border-bottom: 6px solid #fff;
			border-right: 6px solid #fff;
			transform: rotate(45deg);
		}
	}
	.tip {
		margin: 10px 0;
		font-size: 20px;
	}
</style>
